"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var trialIdAdapter = function trialIdAdapter(availableTrials, merchandiseId) {
  if (merchandiseId === _MerchandiseIds.ADDON_CMS) {
    var cmsTrialAvailable = availableTrials.filter(function (t) {
      return t.name === 'cms';
    })[0];

    if (cmsTrialAvailable) {
      return cmsTrialAvailable.trialId;
    }

    return null;
  }

  var trial = availableTrials.filter(function (t) {
    return t.merchandiseId === merchandiseId;
  })[0];
  if (!trial) return null;
  return trial.trialId;
};

var _default = trialIdAdapter;
exports.default = _default;
module.exports = exports.default;